import { Dispatch, SetStateAction } from "react";
import { bulkSignOrchestratorApi } from "@rshbintech.dboul/http";

import {
  DOCUMENT_SIGNING_STAGES,
  DOCUMENT_SIGNING_STATUSES,
  SIGNING_STATUSES,
} from "../constants";
import { BatchedDocumentsItemMap, SignedDocument } from "../types";
import { getDocumentsToCheckStatuses } from "./get-documents-to-check-statuses";
import { processError } from "./process-error";
import { hasUnprocessedDocument } from "./has-unprocessed-document";

export const checkDocumentsStatuses = async (
  taskId: string,
  isLastStepBeforeFinish: boolean,
  documentsToView: SignedDocument[],
  setBatch: Dispatch<SetStateAction<BatchedDocumentsItemMap>>,
  setStatus: Dispatch<SetStateAction<SIGNING_STATUSES>>,
  setBatchSignStage: Dispatch<SetStateAction<number>>,
  setDocumentsToView: (value: SetStateAction<SignedDocument[]>) => void,
  setError: Dispatch<SetStateAction<string>>
): Promise<void> => {
  try {
    // проверяем, есть ли документы, доступные для подписания
    // в том числе еще не получившие ккб и не отправленные на проверку
    const someDocumentsToCheck = hasUnprocessedDocument(documentsToView);

    if (!someDocumentsToCheck) {
      if (isLastStepBeforeFinish) {
        setStatus(SIGNING_STATUSES.SIGNING_COMPLETED);
      }

      setBatchSignStage(DOCUMENT_SIGNING_STAGES.EMPTY);
      setBatch({});

      return;
    }

    // отбираем документы, которые отправлены на подписание (готовы к проверке статуса)
    const documentsToCheckStatuses =
      getDocumentsToCheckStatuses(documentsToView);

    if (!documentsToCheckStatuses.length) {
      if (isLastStepBeforeFinish) {
        setStatus(SIGNING_STATUSES.SIGNING_COMPLETED);

        return;
      }

      setBatchSignStage(DOCUMENT_SIGNING_STAGES.EMPTY);
      setBatch({});

      return;
    }

    const getDocumentsStatusesResult =
      await bulkSignOrchestratorApi.api.getDocumentsStatuses(taskId, {
        documents: documentsToCheckStatuses,
      });

    const { documents = [] } = getDocumentsStatusesResult.data;

    const isValidStatuses = documents.filter(
      (document) =>
        document.state === DOCUMENT_SIGNING_STATUSES.ERROR ||
        document.state === DOCUMENT_SIGNING_STATUSES.SUCCESS
    );

    if (isValidStatuses.length) {
      setDocumentsToView((prev) =>
        prev.map((document) => {
          const searchedDocument = isValidStatuses.find(
            (documentWithStatus) => document.id === documentWithStatus.id
          );

          return searchedDocument
            ? {
                ...document,
                status: searchedDocument.state,
                errorText: searchedDocument.errorText || "",
                documentStatus: {
                  status: searchedDocument.state,
                  errorText: searchedDocument.errorText || "",
                },
                signatureInfo: {
                  ...document.signatureInfo,
                  signingStage:
                    searchedDocument.state ===
                      DOCUMENT_SIGNING_STATUSES.SUCCESS &&
                    !searchedDocument.errorText
                      ? DOCUMENT_SIGNING_STAGES.FINISHED
                      : DOCUMENT_SIGNING_STAGES.FINISHED_WITH_ERROR,
                },
              }
            : document;
        })
      );
    }

    setBatchSignStage(DOCUMENT_SIGNING_STAGES.EMPTY);
    setBatch({});
    if (isLastStepBeforeFinish) {
      setStatus(SIGNING_STATUSES.SIGNING_COMPLETED);
    }
  } catch (error) {
    processError(error, setError);
  }
};
